export const PATHS = {
  // // 管理者テンプレ
  // TEMPLATE_LIST_A: "/template-list-a",
  // TEMPLATE_DETAIL_A: "/template-detail-a",
  // TEMPLATE_DETAILCREATE_A: "/template-detail-create-a",
  // TEMPLATE_DETAILEDIT_A: "/template-detail-edit-a",
  // TEMPLATE_DETAILPREVIEW_A: "/template-detail-preview-a",
  // TEMPLATE_DETAILRESULT_A: "/template-detail-result-a",
  // FOR_A: "/for-a",

  // // ユーザーテンプレ
  // TEMPLATE_LIST_B: "/template-list-b",
  // TEMPLATE_DETAIL_B: "/template-detail-b",

  // 認証
  AUTH_SIGN_IN: "/signin",
  AUTH_SIGN_UP: "/signup",
  AUTH_PASSWORD_RESET: "/password-reset",
  AUTH_PASSWORD_FORGET: "/password-forget",
  AUTH_ACCOUNT_MAIL_SEND: "/account-mail",
  AUTH_PASSWORD_CREATE: "/password-create",
  AUTH_PASSWORD_MAIL_SEND: "/password-mail",

  // ホーム
  HOME: "/home",

  // エアコン
  REPORT_AIRCON_LIST: "/report-aircon",
  REPORT_AIRCON_DETAIL: "/report-aircon/:id",

  // 床
  REPORT_FLOOR_LIST: "/report-floor",
  REPORT_FLOOR_DETAIL: "/report-floor/:id",

  // フード
  REPORT_FOOD_LIST: "/report-food",
  REPORT_FOOD_DETAIL: "/report-food/:id",

  // フリー
  REPORT_FREE_LIST: "/report-free",
  REPORT_FREE_DETAIL: "/report-free/:id",

  // 受注書
  ORDER_LIST: "/order-form",
  ORDER_DETAIL: "/order-form/:id",

  // メーカー管理
  MANUFACTURER_LIST: "/manufacture",
  MANUFACTURER_DETAIL: "/manufacture/:id",

  // 営業担当者管理
  SALES_PERSON_LIST: "/admin/sales-person",
  SALES_PERSON_DETAIL: "/admin/sales-person/:id",

  // 作業名称管理
  WORK_TYPE_LIST: "/admin/work-type",
  WORK_TYPE_DETAIL: "/admin/work-type/:id",

  // // 利用規約
  // TERMS: "/terms",
  // PRIVACY_POLICY: "/privacy-policy",

  // ユーザー一覧
  ACCOUNT_LIST: "/user",
  ACCOUNT_DETAIL: "/user/:id",

  NOTFOUND: "*",
} as const;
